<script lang="ts" setup>
import type { AlertProps } from '@/models/global-alert'

const props = defineProps<AlertProps>()
</script>

<template>
  <IaAlert
    v-bind="props"
    class="!w-fit mx-auto"
  />
</template>
